var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"article__authors"},[(_vm.authors && _vm.authors.length > 0)?_vm._l((_vm.authors),function(author){return _c('ArticleAuthor',{key:author.external_id,attrs:{"author":author}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }